// extracted by mini-css-extract-plugin
export var mobileTypeText = "table-module--mobileTypeText--ZtDL6";
export var table = "table-module--table--r0Usy";
export var tableWrapper = "table-module--tableWrapper--P79uZ";